import { CSSProperties, MouseEvent, ReactNode, useState } from 'react';
import classNames from 'classnames';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
interface Params {
  magnifiedImageHeight: number;
  magnifiedImageWidth: number;
  zoomLevel?: number;
}
export function useImageMagnifier({
  magnifiedImageHeight,
  magnifiedImageWidth,
  zoomLevel = 1.8
}: Params): {
  magnifiedImage: string | null;
  magnifier: ReactNode | null;
  magnifiedImageClassName: string;
  magnifiedImageStyle: CSSProperties;
  handleMouseEnter: (e: MouseEvent<HTMLElement>, imageSrc: string) => void;
  handleMouseMove: (e: MouseEvent<HTMLElement>) => void;
  handleMouseLeave: () => void;
} {
  const {
    isMobile
  } = useMobileDetect();
  const [magnifiedImage, setMagnifierImage] = useState<string | null>(null);
  const [[x, y], setXY] = useState([0, 0]);
  const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
  const magnifierWidth = magnifiedImageWidth / zoomLevel;
  const magnifierHeight = magnifiedImageHeight / zoomLevel;
  const handleMouseEnter = (e: MouseEvent<HTMLElement>, imageSrc: string) => {
    if (isMobile) return;

    // update image size and turn-on magnifier
    const elem = e.currentTarget;
    const {
      width,
      height
    } = elem.getBoundingClientRect();
    setSize([width, height]);
    setMagnifierImage(imageSrc);
  };
  const handleMouseMove = (e: MouseEvent<HTMLElement>) => {
    if (isMobile) return;

    // update cursor position
    const elem = e.currentTarget;
    const {
      top,
      left
    } = elem.getBoundingClientRect();

    // calculate cursor position on the image
    const mouseX = e.pageX - left - window.pageXOffset;
    const mouseY = e.pageY - top - window.pageYOffset;
    const minX = magnifierWidth / 2;
    const maxX = imgWidth - magnifierWidth / 2;
    const minY = magnifierHeight / 2;
    const maxY = imgHeight - magnifierHeight / 2;
    setXY([mouseX <= minX || mouseX >= maxX ? x : mouseX, mouseY <= minY || mouseY >= maxY ? y : mouseY]);
  };
  const handleMouseLeave = () => {
    if (isMobile) return;

    // close magnifier
    setMagnifierImage(null);
  };
  return {
    magnifiedImage,
    magnifier: magnifiedImage ? <>
                <div className='absolute right-0 top-0 z-10 bg-white bg-opacity-60' style={{
        width: imgWidth,
        height: y - magnifierHeight / 2
      }} />
                <div className='absolute bottom-0 right-0 z-10 bg-white bg-opacity-60' style={{
        width: imgWidth,
        height: imgHeight - y - magnifierHeight / 2
      }} />
                <div className='absolute left-0 z-10 bg-white bg-opacity-60' style={{
        width: x - magnifierWidth / 2,
        height: magnifierHeight,
        top: y - magnifierHeight / 2
      }} />
                <div className='absolute right-0 z-10 bg-white bg-opacity-60' style={{
        width: imgWidth - (x + magnifierWidth / 2),
        height: magnifierHeight,
        top: y - magnifierHeight / 2
      }} />
            </> : null,
    magnifiedImageClassName: classNames('pointer-events-none absolute z-50 bg-no-repeat opacity-100 shadow hidden border bg-text-white lg:block', magnifiedImage ? '' : 'none'),
    magnifiedImageStyle: {
      backgroundImage: `url('${magnifiedImage}')`,
      //calculate zoomed image size
      backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
      //calculete position of zoomed image.
      backgroundPositionX: `${-x * zoomLevel + magnifiedImageWidth / 2}px`,
      backgroundPositionY: `${-y * zoomLevel + magnifiedImageHeight / 2}px`,
      left: `-${magnifiedImageWidth + 10}px`,
      top: '-60px',
      // top: `${y - magnifiedImageHeight / 2}px`,
      // left: `${x - magnifiedImageWidth / 2}px`,

      width: `${magnifiedImageWidth}px`,
      height: `${magnifiedImageHeight}px`
    },
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave
  };
}